const row = {
  namespaced: true,
  state: {
    current_page_index: 0,
    // 整棵树
    data: {
      width: 375,
      height: 667,
      in: 'move',
      selectPosition: '1', // 1：单个职位 2：多个职位
      previewUrl: '',
      pages: {
        cmps: []
      }
    },
    companyDetail: {},
    previewDialog: false,
    templateDialog: false, // 模板选择弹框
    templateData: {} // 默认模板数据
  },
  mutations: {
    ADD_module: (state, val) => {
      state.widgets.push(val)
      console.log(state.widgets)
    },
    change_current_page_index: (state, val) => {
      state.current_page_index = val
    },
    change_widgets: (state, val) => {
      state.widgets = val
    },
    SET_previewUrl: (state, val) => {
      state.data.previewUrl = val
    },
    set_music: (state, val) => {
      state.data.music = val.id
      state.data.musicname = val.fileName
      state.data.musicPath = val.musicPath
      state.data.musicLoop = val.musicLoop
      console.log(val)
    },
    SET_data: (state, val) => {
      state.data = val
    },
    SET_pages: (state, val) => {
        console.log('SET_pages')
        state.data.pages = val
    },
    // 设置当前模块数据
    SET_curr_module_data: (state, val) => {
      const { module, cmpIndex } = { ...val }
      state.data.pages.cmps[cmpIndex] = module
    },
    // 设置模板数据
    SET_Template_data: (state, val) => {
      state.templateData = val
    },
    setCompanyDetail: (state, val) => {
      state.companyDetail = val
    },
    setSelectPosition: (state, val) => {
      state.data.selectPosition = val
    },
    setPreviewDialog: (state, val) => {
      state.previewDialog = val
    },
    setTemplateDialog: (state, val) => {
      state.templateDialog = val
    }
  },
  actions: {},
  getters: {
    // 拖拽的提示
    DragPromptIsShow(state) {
      if (state.body) {
        if (state.body.children.length > 0) {
          return false
        } else {
          return true
        }
      }
    }
  }
}

export default row
